if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      onSlideChanged(event) {
        if (event.detail.currentElement) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia.classList.add("is-active");
        const imageWrapper = activeMedia.querySelector(".image-wrapper")
        if(imageWrapper){
          imageWrapper.classList.remove("not-loading");
          const img = imageWrapper.querySelector("img");
          if(img && img.complete) {
            imageWrapper.classList.add("not-loading");
          } else if(img) {
            img.addEventListener("load", () => imageWrapper.classList.add("not-loading"), {once: true});
          }
        }
        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            if (activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
            if (this.elements.thumbnails.slider) this.elements.thumbnails.resetPages();
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === "stacked"
          ) {
            activeMedia.scrollIntoView({ behavior: "smooth" });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        
        this.elements.thumbnails
          .querySelectorAll("li.thumbnail-list__item")
          .forEach((element) => element.classList.remove("is-active"));
        thumbnail.classList.add("is-active");

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.button--next-thumb, .button--prev-thumb');
  
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      const mediaGallery = this.closest('media-gallery');
      if (!mediaGallery) return;

      const parent = mediaGallery.querySelector('slider-component.thumbnail-slider');
      if (!parent) return;

      const lengthMedia = parseInt(parent.getAttribute('length-media'), 10);
      const currentButton = parent.querySelector('button.thumbnail[aria-current="true"]');
      if (!currentButton) return;

      const listItem = currentButton.closest('li.thumbnail-list__item');
      const position = parseInt(listItem.getAttribute('data-media-position'), 10);

      let newPosition;
      if (this.classList.contains('button--next-thumb')) {
        newPosition = (position + 1 > lengthMedia) ? 1 : position + 1;
      } else {
        newPosition = (position - 1 < 1) ? lengthMedia : position - 1;
      }

      const targetButton = parent.querySelector(`li.thumbnail-list__item[data-media-position="${newPosition}"] button.thumbnail`);
      if (targetButton) {
        targetButton.click();
      }
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  const handleMainArrowClick = function(e) {
    if (window.innerWidth >= 990) {
      e.preventDefault();
      e.stopPropagation();

      const mediaGallery = this.closest('media-gallery');
      if (!mediaGallery) return;

      const thumbnailsSlider = mediaGallery.querySelector('slider-component[id^="GalleryThumbnails"]');
      if (!thumbnailsSlider) return;
      
      const currentButton = thumbnailsSlider.querySelector('button.thumbnail[aria-current="true"]');
      if (!currentButton) return;

      const listItem = currentButton.closest('li.thumbnail-list__item');
      
      const allThumbnails = Array.from(thumbnailsSlider.querySelectorAll('li.thumbnail-list__item'));
      const validThumbnails = allThumbnails.filter(
        (li, index) => !li.classList.contains('thumbnail-list_item--variant') || index === 0
      );

      const currentIndex = validThumbnails.indexOf(listItem);
      if (currentIndex === -1) return;

      let newIndex;
      if (this.classList.contains('slider-button--next')) {
        newIndex = (currentIndex + 1 >= validThumbnails.length) ? 0 : currentIndex + 1;
      } else {
        newIndex = (currentIndex - 1 < 0) ? validThumbnails.length - 1 : currentIndex - 1;
      }

      const targetButton = validThumbnails[newIndex].querySelector('button.thumbnail');
      if (targetButton) {
        targetButton.click();
      }
    }
  };

  document.querySelectorAll('slider-component[id^="GalleryViewer"] .slider-button').forEach(btn => {
    btn.addEventListener('click', handleMainArrowClick, true);
  });
});
